var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    viewBox: "0 0 68 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 65,
    rx: 10,
    fill: "#EEF8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8571 22V24.4444H46.8543L36.4286 34.9383L31.2156 29.6914C31.1029 29.5779 30.9691 29.4878 30.8218 29.4264C30.6745 29.3649 30.5166 29.3333 30.3571 29.3333C30.1977 29.3333 30.0398 29.3649 29.8925 29.4264C29.7452 29.4878 29.6113 29.5779 29.4986 29.6914L17 42.2717L18.7171 44L30.3571 32.2839L35.5701 37.5308C35.6828 37.6443 35.8166 37.7344 35.9639 37.7958C36.1112 37.8573 36.2691 37.8889 36.4286 37.8889C36.588 37.8889 36.7459 37.8573 36.8932 37.7958C37.0405 37.7344 37.1744 37.6443 37.2871 37.5308L48.5714 26.1728V34.2222H51V22H38.8571Z",
    fill: "#16A249"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIcon);
export default __webpack_public_path__ + "static/media/network-icon.ec87feca97acd5df2aef90cfe7f81c4e.svg";
export { ForwardRef as ReactComponent };